import ParameterErrors from '../errors/ParameterErrors';
import ParseError from '../errors/ParseError';
import CubeFace from '../enums/CubeFace';
const { throwNotProvided, throwNotOfType} = ParameterErrors;
export default class ExportedCubeJsonFace{
	constructor(props){
		const {cubeFace, cubeFaceChar, imageRelativePath, tiledImageFolderRelativePath}=props;
		
		if(cubeFace===undefined||cubeFace===null)
			throwNotProvided('cubeFace');
		this._cubeFace = cubeFace;
		
		if(cubeFaceChar===undefined||cubeFaceChar===null)
			throwNotProvided('cubeFaceChar');
		this._cubeFaceChar = cubeFaceChar;
		
		if(imageRelativePath===undefined||imageRelativePath===null)
			throwNotProvided('imageRelativePath');
		this._imageRelativePath = imageRelativePath;
		
		if(tiledImageFolderRelativePath===undefined||tiledImageFolderRelativePath===null)
			throwNotProvided('tiledImageFolderRelativePath');
		this._tiledImageFolderRelativePath = tiledImageFolderRelativePath;
    }
	get cubeFace(){
		return this._cubeFace;
	}      
	get cubeFaceChar(){
		return this._cubeFaceChar;
	}
	get imageRelativePath(){
		return this._imageRelativePath;
	}
	get tiledImageFolderRelativePath(){
		return this._tiledImageFolderRelativePath;
	}	
	static fromJSON(jObject){
		return new ExportedCubeJsonFace({
			cubeFace: CubeFace.parse(jObject.cubeFace),
			cubeFaceChar:jObject.cubeFaceChar,
			imageRelativePath:jObject.imageRelativePath,
			tiledImageFolderRelativePath:jObject.tiledImageFolderRelativePath
		});
	}
}